import { Button } from "antd";
import { useDispatch } from 'react-redux';
import { callNotify } from "../../../../..";
import { useTrackEvent } from "../../../../../components/AnalyticsProvider/useTrackEvent";
import Icon, { ICON_NAME } from "../../../../../components/Icon";
import Menu from "../../../../../components/Menu";
import { selectPermissions, selectTenantId } from "../../../../../util/store/selectors";
import { useSelector } from "../../../../../util/store/store";
import { getKeyWeek } from "../../../../../util/varibles/global";
import { IOperation, IPropsChildren } from "../../../../../util/varibles/interface";
import { ACTION } from "../../../../../util/varibles/permission";
import { selectPlan, TYPE_SUBMIT } from "../../../constants";
import { planOpActions } from "../../../reducer";
import { statusUnAllow } from "../../../util";
import { VALIDATION_STATUS } from "../../../util/validation";

const message = {
    invalid: (error: any) => `Can not send new / update operation to vessel. 
                            There ${error.length > 1 ? 'are' : 'is'} invalid operation on planning calendar, 
                            please correct first and try to send to vessel later.`,
    emptyByCurrentWeek: () => `There is no new / updated operation in current week to send to vessel.`,
    empty: () => `There is no new / updated operation to send to vessel.`
}


interface IProps extends IPropsChildren {
}

const SendPlans: React.FC<IProps> = (props) => {
    const userTenantId = useSelector(selectTenantId);
    const loading = useSelector(selectPlan.loadingSend);
    const operations = useSelector(selectPlan.ops);
    const [canSavePlan, canSendPlan] = useSelector(selectPermissions([
        ACTION.PLAN_OP.SAVE,
        ACTION.PLAN_OP.SEND,
    ]));
    const dispatch = useDispatch();
    const trackEvent = useTrackEvent();

    const handleSubmit = (typeSubmit: TYPE_SUBMIT, operations: any) => {
        if (typeSubmit === TYPE_SUBMIT.CURRENT_WEEK) {
            const currentWeek = getKeyWeek(new Date());
            operations = operations.filter((item: any) => !item.operation.is_active_vessel
                && currentWeek === getKeyWeek(item.activity_log[0].est_start_time));
            if (operations.length === 0) {
                callNotify?.warning({ title: 'Warn', description: message.emptyByCurrentWeek(), });
                return;
            }
        }
        if (operations.length === 0)
            callNotify?.warning({ title: 'Warn', description: message.empty(), });
        else
            checkOperation(operations)
    };

    const handleSave = (operations: any) => {
        checkOperation(operations, true)
    }

    const checkOperation = (operations: IOperation[], isSave?: boolean) => {
        const operationError = operations.filter(item => item.status === VALIDATION_STATUS.ERROR)
        if (operationError.length > 0) {
            callNotify?.error({ title: 'Error', description: message.invalid(operationError) });
        } else {
            dispatch(planOpActions.confirmOpRequest({ operations, isSave }));
            operations.forEach(operation => trackEvent(
                'operation_planned', 'Plan Operation', { operation }
            ));
        }
    }

    const { change, save } = Object.keys(operations).reduce((list: any, key: string) => {
        if (operations[key].operation.tenant_id !== userTenantId)
            return list;

        if (statusUnAllow.has(operations[key].operation.status))
            return list;

        if (!!operations[key].action_type)
            list.change = [...list.change, operations[key]]
        else if (!operations[key].operation.is_active_vessel)
            list.save = [...list.save, operations[key]];
        return list
    }, { change: [], save: [] });

    const data = [...change, ...save];

    const menu = [
        {
            key: '1',
            label: <span className="text-comment">The operations will be sent to vessel (and site side)</span>,
            className: '!cursor-default',
            disabled: true,
        },
        {
            type: 'divider',
        },
        {
            key: 'week',
            label: <div
                className='menu-line'
                data-full={true}
                onClick={() => handleSubmit(TYPE_SUBMIT.ALL, data)}
            >
                Send all plans
            </div>
        },
        {
            key: 'all',
            label: <div
                className='menu-line'
                data-full={true}
                onClick={() => handleSubmit(TYPE_SUBMIT.CURRENT_WEEK, data)}
            >
                Send plans by current week
            </div>
        }
    ]

    return <>
        {canSavePlan && <Button
            className='bt-ghost h-32'
            ghost={true}
            onClick={() => handleSave(change)}
            disabled={change.length === 0}
            icon={<Icon className="mt-[5px]" icon={ICON_NAME.APPROVE} />}
            loading={loading}
        >
            <span>
                Save plan
            </span>
        </Button>}
        {props.children}
        {canSendPlan && <>
            <Menu items={menu} disabled={data.length === 0} classNames={{ root: "max-w-[250px]" }}>
                <Button className='bt-primary h-32' loading={loading}>
                    Send plan
                </Button>
            </Menu>
        </>}
    </>;
}

export default SendPlans;
